const gsmBasic = new Set(
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
);
const gsmExtended = new Set("\f^{}\\[~]|€");

export default function countSmsSegments(value) {
  // Match the trimmed message submitted to the API.
  const characters = Array.from(String(value || "").trim());
  if (!characters.length) return 0;

  const isGsm = characters.every(
    (character) => gsmBasic.has(character) || gsmExtended.has(character)
  );
  const units = characters.map((character) =>
    isGsm ? (gsmExtended.has(character) ? 2 : 1) : character.length
  );
  const length = units.reduce((total, size) => total + size, 0);
  if (length <= (isGsm ? 160 : 70)) return 1;

  const segmentCapacity = isGsm ? 153 : 67;
  let segments = 1;
  let used = 0;
  for (const size of units) {
    // Keep escape sequences and emoji surrogate pairs within one segment.
    if (used + size > segmentCapacity) {
      segments += 1;
      used = 0;
    }
    used += size;
  }
  return segments;
}
